function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".CloseIconNotification_svg__cls-1{fill:none;stroke:#000;stroke-width:2px}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "CloseIconNotification_svg__Group_92",
  "data-name": "Group 92",
  transform: "translate(5.601 6)"
}, React.createElement("path", {
  id: "CloseIconNotification_svg__Line_1",
  d: "M0 0l12 12",
  className: "CloseIconNotification_svg__cls-1",
  "data-name": "Line 1",
  transform: "translate(.399)"
}), React.createElement("path", {
  id: "CloseIconNotification_svg__Line_2",
  d: "M12 0L0 12",
  className: "CloseIconNotification_svg__cls-1",
  "data-name": "Line 2",
  transform: "translate(.399)"
}), React.createElement("path", {
  id: "CloseIconNotification_svg__Rectangle_201",
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 201",
  transform: "translate(-5.601 -6)",
  fill: "none"
}));

var SvgCloseIconNotification = function SvgCloseIconNotification(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxkZWZzPgogICAgICAgIDxzdHlsZT4KICAgICAgICAgICAgLmNscy0xLC5jbHMtMntmaWxsOm5vbmV9LmNscy0xe3N0cm9rZTojMDAwO3N0cm9rZS13aWR0aDoycHh9CiAgICAgICAgPC9zdHlsZT4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJHcm91cF85MiIgZGF0YS1uYW1lPSJHcm91cCA5MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS42MDEgNikiPgogICAgICAgIDxwYXRoIGlkPSJMaW5lXzEiIGQ9Ik0wIDBsMTIgMTIiIGNsYXNzPSJjbHMtMSIgZGF0YS1uYW1lPSJMaW5lIDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC4zOTkpIi8+CiAgICAgICAgPHBhdGggaWQ9IkxpbmVfMiIgZD0iTTEyIDBMMCAxMiIgY2xhc3M9ImNscy0xIiBkYXRhLW5hbWU9IkxpbmUgMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjM5OSkiLz4KICAgICAgICA8cGF0aCBpZD0iUmVjdGFuZ2xlXzIwMSIgZD0iTTAgMGgyNHYyNEgweiIgY2xhc3M9ImNscy0yIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAyMDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01LjYwMSAtNikiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgCloseIconNotification as ReactComponent };


//////////////////
// WEBPACK FOOTER
// /src/assets/img/CloseIconNotification.svg
// module id = 505
// module chunks = 0